module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Eject-b34a459a5921b3b2ce338c0ea57dbba0.svg";